import React, { useMemo, useState } from 'react';
import {
  // AutoInvestmentOffIcon,
  // InvestmentIcon,
  // AutoInvestmentOnIcon,
  Box,
  CIPStatus,
  Enrollment,
  // Hint,
  // InvestmentPathType,
  Text,
} from '@common-fe/common-fe';
import styled from 'styled-components';

import { EnrollmentModal } from '@/modules/employee/Employee/EnrollmentModal';
import useGetPolicyStatusesQuery from '@/modules/employee/EnrollmentDetails/queries/useGetPolicyStatuses.query';

import { PlanTypes } from '../../EnrollmentModal/enrollmentModal.types';
import { Investors } from '../../queries/useGetInvestors.query';

import { EnrollmentCardBlock } from './EnrollmentCardBlock';
import { EnrollmentDates } from './EnrollmentDates';

export const DisplayName = styled(Text)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ENROLLMENT_ITEM_WIDTH_S = '336px';
export const ENROLLMENT_ITEM_WIDTH_L = '400px';

interface Props {
  enrollment: Enrollment;
  onSelect?: () => void;
  isDetailsMode?: boolean;
  statusColor?: string;
  investorsData?: Investors;
  employeeName?: string;
  clickMode?: boolean;
  width?: string;
  wrapperStyle?: React.CSSProperties;
}

export const EnrollmentItem: React.FC<Props> = ({
  enrollment,
  onSelect,
  statusColor,
  isDetailsMode,
  employeeName,
  investorsData,
  clickMode,
  width,
  wrapperStyle,
}) => {
  const { statuses } = useGetPolicyStatusesQuery(enrollment?.policyId);
  const isNotVerified = useMemo(
    () =>
      (enrollment?.CIPStatus === CIPStatus.Fail || enrollment?.CIPStatus === CIPStatus.Question) &&
      enrollment.isCIPRequired,
    [enrollment]
  );
  const [editModalVisible, setEditModalVisible] = useState(false);

  return (
    <Box>
      <Box onClick={onSelect} style={wrapperStyle || undefined}>
        <EnrollmentCardBlock
          enrollment={enrollment}
          pendingTradesAmount={investorsData?.pendingTradesAmount}
          investorEnrollmentId={investorsData?.accountId}
          style={{
            width: width,
            cursor: clickMode ? 'pointer' : 'default',
          }}
        />

        {/* <Box margin={{ bottom: 'spacing12' }}> */}
        {/*   <EnrollmentDatesInfo enrollment={enrollment} /> */}
        {/* </Box> */}
        {/* { */}
        {/*   enrollment.spentItByDate  */}
        {/*     ? ( */}
        {/*       <Box  */}
        {/*         data-testid="enrollment-investment-message" */}
        {/*         direction="row" */}
        {/*         pad={{ vertical: 'spacing12', horizontal: 'spacing16' }}  */}
        {/*         border={{ color: 'border2', size: 'small' }}  */}
        {/*         background="canvas" */}
        {/*         round="container1Round" */}
        {/*         margin={{ bottom: 'spacing12' }}  */}
        {/*       > */}
        {/*         <AttentionIcon /> */}
        {/*         <Text */}
        {/*           color="textBody"  */}
        {/*           size="small"  */}
        {/*           margin={{ left: 'spacing12' }}  */}
        {/*           weight={500}  */}
        {/*         > */}
        {/*           The employee can spend {enrollment.type} dollars up to  */}
        {/*           [{dayjs(enrollment.spentItByDate).format(DEFAULT_DATE_FORMAT)}] */}
        {/*         </Text> */}
        {/*       </Box>  */}
        {/*     ) */}
        {/*     : null  */}
        {/* } */}
        <EnrollmentModal
          isVisible={editModalVisible}
          onSetVisible={setEditModalVisible}
          enrollment={enrollment}
          statuses={statuses}
          planType={PlanTypes.SAVING}
          isEdit
          isWithoutButton
        />
      </Box>
      {!isDetailsMode && !isNotVerified && (
        <EnrollmentDates
          coverageDateStart={enrollment.coverageDateStart}
          coverageDateEnd={enrollment.coverageDateEnd}
          submitClaimsDateEnd={enrollment.submitClaimsDateEnd}
          statusColor={statusColor}
          statuses={statuses}
          enrollmentStatus={enrollment.enrollmentStatus}
          coveragePeriods={enrollment.coveragePeriods}
          employeeName={employeeName}
          externalDeductibleMet={enrollment.deductibleMetDate}
          isRollover={enrollment?.isRollover}
          electionPeriods={enrollment?.electionPeriods}
        />
      )}
    </Box>
  );
};
